import { Creator, StripeAccountType } from '@typings/graphql-models';
import * as configuration from '@configuration/client';

const getMORStripeAccount = (creator?: Pick<Creator, 'stripeAccountType' | 'stripe_account_id'> | null): string | null => {
  if (!creator) {
    return null;
  }

  if (creator.stripeAccountType === StripeAccountType.Express) {
    return configuration.NOODLE_STRIPE_ACCOUNT_ID || null;
  }

  if (creator.stripe_account_id) {
    return creator.stripe_account_id;
  }

  return null;
};

export default getMORStripeAccount;
